//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FormLabelPassword',
  props: {
    errors: {
      default: () => [],
      type: Array,
    },
    valid: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
    label: {
      default: '',
      type: String,
    },
    levelForceMsg: {
      type: String,
      default: '',
    },
    classForce: {
      type: String,
      default: '',
    },
    levelForce: {
      type: Number,
      default: 0,
    },
  },
}
